import React from 'react';
import { UserIcon, SunIcon, MoonIcon } from 'lucide-react';
interface HeaderProps {
  isDarkMode: boolean;
  onToggleDarkMode: () => void;
}
export function Header({
  isDarkMode,
  onToggleDarkMode
}: HeaderProps) {
  return <header className={`h-14 backdrop-blur border-b shrink-0 z-20 flex items-center justify-between px-6 transition-colors duration-300 ${isDarkMode ? 'bg-olympian-navy/80 border-olympian-border' : 'bg-white/90 border-gray-200'}`} data-id="element-184">
      <div className="flex items-center gap-3" data-id="element-185">
        <span className="text-lg font-bold tracking-wide text-theme" data-id="element-186">
          Command Center
        </span>
      </div>

      <div className="flex items-center gap-2" data-id="element-187">
        <button onClick={onToggleDarkMode} className="p-2 rounded-lg transition-all duration-200 bg-olympian-surface border border-olympian-border text-olympian-textMuted hover:text-olympian-gold" aria-label={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'} title={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'} data-id="element-188">
          {isDarkMode ? <SunIcon className="w-4 h-4" data-id="element-189" /> : <MoonIcon className="w-4 h-4" data-id="element-190" />}
        </button>

        <div className="w-px h-6 bg-olympian-border mx-2" data-id="element-191" />

        <div className="flex items-center gap-3" data-id="element-192">
          <div className="text-right hidden sm:block" data-id="element-193">
            <div className="text-sm font-medium text-theme leading-tight" data-id="element-194">
              Alex Mercer
            </div>
            <div className="text-[10px] text-olympian-textMuted" data-id="element-195">
              Senior Loan Officer
            </div>
          </div>
          <div className="w-8 h-8 rounded-full flex items-center justify-center border bg-olympian-surface border-olympian-border" data-id="element-196">
            <UserIcon className="w-4 h-4 text-olympian-textMuted" data-id="element-197" />
          </div>
        </div>
      </div>
    </header>;
}